import React, { ReactNode } from 'react';

import {
  Box,
  BoxProps,
  Center,
  CenterProps,
  FlexProps,
  HStack,
  Stack,
  StackProps,
} from '@chakra-ui/react';
import { customTheme } from 'theme';

import { PageHeaderWithIcon } from 'components/DataDisplay';
import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import {
  DashboardOverviewTooltip,
  DashboardOverviewTooltipProps,
} from 'containers/Dashboard/utils/OverviewDashboardTooltip';

export interface DashboardOverviewCardProps {
  content: ReactNode;
  label?: ReactNode;
  subHeader?: ReactNode;
  rightHeader?: ReactNode;
  tooltip?: DashboardOverviewTooltipProps;
  isLoading?: boolean;
  styles?: {
    contentWrapper?: CenterProps;
    rightHeader?: { hStack?: StackProps; box?: BoxProps };
  };
  noDataMessage?: ReactNode;
  noData?: boolean;
  paddingX?: string | number;
  paddingTop?: string | number;
  paddingBottom?: string | number;
}

export const DashboardWidget: React.FC<DashboardOverviewCardProps> = props => {
  const {
    label,
    subHeader,
    content,
    tooltip,
    rightHeader,
    isLoading = false,
    styles,
    noData,
    noDataMessage,
    paddingX = 5,
    paddingTop = 5,
    paddingBottom = 5,
  } = props;

  return (
    <Box pt={paddingTop} pb={paddingBottom} px={2} w="full" h="full">
      <Stack w="full" h="full" spacing={subHeader ? 1 : 4}>
        <Stack>
          <HStack w="full" justify="space-between">
            <HStack px={paddingX} w="full">
              <Stack spacing={0} w="full">
                <PageHeaderWithIcon
                  label={label}
                  fontSize="lg"
                  reversed
                  labelStyles={{ fontWeight: 600 }}
                />
                <Box
                  color={customTheme.colors.dashboardRowSubHeader}
                  pb={!!subHeader ? 0 : 2.5}
                  w="full"
                  fontSize="sm"
                >
                  {subHeader}
                </Box>
              </Stack>
            </HStack>
            <HStack justify="flex-end" {...styles?.rightHeader?.hStack}>
              {tooltip && <DashboardOverviewTooltip {...tooltip} />}
              <Box {...styles?.rightHeader?.box}>{rightHeader}</Box>
            </HStack>
          </HStack>
        </Stack>
        <Center
          w="full"
          h="full"
          py={2}
          overflowY="auto"
          px={paddingX}
          {...styles?.contentWrapper}
        >
          {isLoading ? (
            <CustomSpinner />
          ) : noData ? (
            <Box pb={8} color={customTheme.colors.gray['300']}>
              {noDataMessage || 'No Data Available'}
            </Box>
          ) : (
            content
          )}
        </Center>
      </Stack>
    </Box>
  );
};
